import { cn } from '@lib/utils';
import { ExternalLinkIcon } from 'lucide-react';
import React from 'react';

type ExternalLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
  iconSize?: number;
  showIcon?: boolean;
  title?: string;
};

export const ExternalLink: React.FC<ExternalLinkProps> = (props) => {
  const { children, className, href, iconClassName, iconSize = 16, showIcon = true, title } = props;
  const displayTitle = title ?? (typeof children === 'string' ? children : href);

  return (
    <a
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      title={displayTitle}
      className={cn(
        'flex items-center gap-1 text-blue-600 hover:underline min-w-0',
        showIcon ? 'inline-flex' : 'inline-block',
        className,
      )}
    >
      <span className="min-w-0 truncate">{children}</span>
      {showIcon && (
        <ExternalLinkIcon
          className={cn('shrink-0 inline-block', iconClassName)}
          size={iconSize}
        />
      )}
    </a>
  );
};
